// import logo from './logo.svg';
import './App.css';
import React from 'react'
import logo from './images/logo.png';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom'

import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig.js';

import ParishionerList from './components/ParishionerList.js'
import MainMenu from './components/MainMenu.js'
import PrintTaxReceipt from './components/PrintTaxReceipt.js';
import Contribution from './components/Contribution.js';
import CommunityMember from './components/CommunityMember.js';
import AddCommunityMember from './components/AddCommunityMember.js';
import ReportYearlyContribution from './components/ReportYearlyContribution.js';
import ReportYearlyAll from './components/ReportYearlyAll.js';
import ReportLanding from './components/ReportLauncher.js';

function MasterPage() {
  const { instance } = useMsal();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

    return (
      <MsalProvider instance={instance}>
        <UnauthenticatedTemplate><div>Not Logged In</div>
          <div><button onClick={handleLoginRedirect}>Login</button></div>
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <BrowserRouter>
            <div>
            <MasterPageHeader handleLoginRedirect={handleLoginRedirect} handleLogoutRedirect={handleLogoutRedirect} />
              <MainContent />
              <MasterPageFooter />
            </div>
          </BrowserRouter>
        </AuthenticatedTemplate>
      </MsalProvider>
    );
}

function MasterPageDev() {
  const { instance } = useMsal();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

  return (
    <MsalProvider instance={instance}>
      <BrowserRouter>
        <div>
          <MasterPageHeader handleLoginRedirect={handleLoginRedirect} handleLogoutRedirect={handleLogoutRedirect} />
          <MainContent />
          <MasterPageFooter />
        </div>
      </BrowserRouter>
    </MsalProvider>
  );
}

function MasterPageHeader({handleLoginRedirect, handleLogoutRedirect}) {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  return (
    <header>
      {/*<!-- Header content -->*/}
      <img alt="Logo" src={logo} />
      <div>
        <div className="level">
          <div className="level-item title">
            {activeAccount ? <div>You are logged in as {activeAccount.name} <a className='App-link' href='' onClick={handleLogoutRedirect}>Logout</a></div> : <div>You are not logged in <a className='App-link' href='' onClick={handleLoginRedirect}>Login</a></div>}
          </div>
        </div>
      </div>
      <div>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            {/* <li><Link to="/ParishionerList">Parishioner List</Link></li> */}
            {/* <!-- <li><router-link to="/about">About</router-link></li> --> */}
            {/* <!-- <li><router-link to="/contact">Contact</router-link></li> --> */}
          </ul>
        </nav>
      </div>
    </header>
  )
}

function MasterPageFooter() {
  return (
    <footer>
      {/* <!-- Footer content --> */}
    </footer>
  )
}

function MainContent() {

  return (
    <div>
      <Routes>
        <Route path="/" element={<MainMenu />} />
        <Route path="/CommunityList" element={<ParishionerList />} />
        <Route path="/PrintTaxReceipt" element={<PrintTaxReceipt pdfUrl="hbtog_receipt.pdf" />} />
        <Route path='/Contribution/:contribution_id' Component={Contribution} />
        <Route path="/CommunityMember/:member_id" Component={CommunityMember} />
        <Route path="/CommunityMember/new" Component={AddCommunityMember} />
        <Route path="/ReportLanding" Component={ReportLanding} />
        <Route path="/ReportYearlyContribution" Component={ReportYearlyContribution} />
        <Route path="/ReportYearlyContribution/:year" Component={ReportYearlyContribution} />
        <Route path="/ReportYearlyAll" Component={ReportYearlyAll} />
        <Route path="/ReportYearlyAll/:year" Component={ReportYearlyAll} />
      </Routes>
    </div>
  )
}

export default function App({ instance }) {
  if (process.env.NODE_ENV === 'development')
    return <MsalProvider instance={instance}><MasterPageDev /></MsalProvider>;
  else
    return <MsalProvider instance={instance}><MasterPage /></MsalProvider>
}
